export function chunkArray<T>(array: T[], parts: number): T[][] {
	const result: T[][] = [];
	const size = Math.ceil(array.length / parts);
	let index = 0;

	while (index < array.length) {
		result.push(array.slice(index, index + size));
		index += size;
	}

	return result;
}

export function isDefined<T>(value: T | undefined | null): value is T {
	return value !== undefined && value !== null && (typeof value !== 'string' || !!value);
}
